import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import Header from './header';
import Sidebar from './sidebar';
import '../style/familyDetails.css';
import { Button } from 'antd';

const FamilyDetails = () => {
    const { id } = useParams(); // Get the dynamic family ID from the URL
    const [familyDetails, setFamilyDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchFamilyDetails = async () => {
            try {
                const response = await axios.get(`https://ward3-chandrapur-api.palikaapp.com/api/family/${id}/details`);
                setFamilyDetails(response.data);
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };
        fetchFamilyDetails();
    }, [id]);

    if (error) {
        return <div className="error text-red-500 text-center mt-4">Error: {error.message}</div>;
    }

    return (
        <div className="flex flex-col lg:flex-row min-h-screen bg-gray-100">
            {/* Sidebar */}
            <div className="lg:w-1/5 bg-gray-100">
            <Header />
                
            </div>

            {/* Main Content */}
            <div className="lg:w-4/5 p-4 lg:p-8">
            <Sidebar />
                {/* Action Buttons */}
                <div className="flex flex-wrap justify-center lg:justify-center gap-4 mt-6 pt-20">
                    <Link to="add-death-form">
                        <Button size="large" type="primary" className="w-32">
                            मृत्यु
                        </Button>
                    </Link>
                    <Link to="add-transfer-form">
                        <Button size="large" type="primary" className="w-32">
                            बसाइ सराइ
                        </Button>
                    </Link>
                    <Link to="add-birth-form">
                        <Button size="large" type="primary" className="w-32">
                            जन्म
                        </Button>
                    </Link>
                </div>

                {/* Family Details */}
                <div className="family-details mt-10 bg-white shadow-lg rounded-lg p-6">
                    <h1 className="text-2xl font-bold text-center lg:text-left">
                        परिवारको बिस्तृत बिवरण
                    </h1>

                    {loading ? (
                        <div className="text-center mt-4">Loading...</div>
                    ) : familyDetails ? (
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
                            {/* Family ID */}
                            <div>
                                <h3 className="font-semibold">Family ID</h3>
                                <p>{familyDetails.familyId?.id || 'N/A'}</p>
                            </div>

                            {/* Agriculture Type */}
                            <div>
                                <h3 className="font-semibold">Agriculture Type</h3>
                                <p>{familyDetails.familyId?.agricultureType || 'N/A'}</p>
                            </div>

                            {/* Waste Management */}
                            <div>
                                <h3 className="font-semibold">Waste Management</h3>
                                <p>{familyDetails.familyId?.wasteManagement || 'N/A'}</p>
                            </div>

                            {/* Remarks */}
                            <div>
                                <h3 className="font-semibold">Remarks</h3>
                                <p>{familyDetails.familyId?.remarks || 'N/A'}</p>
                            </div>

                            {/* Disabilities */}
                            <div>
                                <h3 className="font-semibold">Disability</h3>
                                <p>Id: {familyDetails.disabilities?.id || 'N/A'}</p>
                                <p>Age: {familyDetails.disabilities?.age || 'N/A'}</p>
                            </div>

                            {/* Education */}
                            <div>
                                <h3 className="font-semibold">Education</h3>
                                <p>Id: {familyDetails.education?.id || 'N/A'}</p>
                                <p>Type: {familyDetails.education?.educationType || 'N/A'}</p>
                                <p>Number: {familyDetails.education?.number || 'N/A'}</p>
                            </div>

                            {/* Age */}
                            <div>
                                <h3 className="font-semibold">Age</h3>
                                <p>{familyDetails.familyAge?.age || 'N/A'}</p>
                            </div>

                            {/* Cooking Source */}
                            <div>
                                <h3 className="font-semibold">Cooking Source</h3>
                                <p>{familyDetails.familyService?.cookingSource || 'N/A'}</p>
                            </div>

                            {/* Income and Expenses */}
                            <div>
                                <h3 className="font-semibold">Family Income and Expenses</h3>
                                <p>Monthly Income: {familyDetails.familyIncomeAndExpenses?.monthlyIncome || 'N/A'}</p>
                                <p>Major Source: {familyDetails.familyIncomeAndExpenses?.incomeMajorSource || 'N/A'}</p>
                                <p>Monthly Expenses: {familyDetails.familyIncomeAndExpenses?.monthlyExpenses || 'N/A'}</p>
                            </div>

                            {/* Family Owner */}
                            <div>
                                <h3 className="font-semibold">Family Owner</h3>
                                <p>Owner Name (Eng): {familyDetails.familyOwner?.ownerNameEng || 'N/A'}</p>
                                <p>Owner Name (Np): {familyDetails.familyOwner?.ownerNameNp || 'N/A'}</p>
                                <p>Father's Name: {familyDetails.familyOwner?.ownerFatherName || 'N/A'}</p>
                                <p>Grandfather's Name: {familyDetails.familyOwner?.ownerGrandFatherName || 'N/A'}</p>
                                <p>Mother's Name: {familyDetails.familyOwner?.ownerMotherName || 'N/A'}</p>
                                <p>Mother Tongue: {familyDetails.familyOwner?.motherTongue || 'N/A'}</p>
                                <p>Caste: {familyDetails.familyOwner?.caste || 'N/A'}</p>
                                <p>Religion: {familyDetails.familyOwner?.religion || 'N/A'}</p>
                                <p>Citizenship No: {familyDetails.familyOwner?.citizenshipNo || 'N/A'}</p>
                                <p>Citizenship District: {familyDetails.familyOwner?.citizenshipDistrict || 'N/A'}</p>
                                <p>Address: {familyDetails.familyOwner?.ownerAddress || 'N/A'}</p>
                                <p>Phone: {familyDetails.familyOwner?.phone || 'N/A'}</p>
                                <p>Email: {familyDetails.familyOwner?.email || 'N/A'}</p>
                            </div>

                            {/* Family Population */}
                            <div>
                                <h3 className="font-semibold">Family Population</h3>
                                <p>Members: {familyDetails.familyPopulation?.memberNo || 'N/A'}</p>
                                <p>Males: {familyDetails.familyPopulation?.maleNo || 'N/A'}</p>
                                <p>Females: {familyDetails.familyPopulation?.femaleNo || 'N/A'}</p>
                                <p>Others: {familyDetails.familyPopulation?.othersNo || 'N/A'}</p>
                            </div>
                        </div>
                    ) : (
                        <p className="text-center text-gray-500">No data available</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FamilyDetails;
